export default {
  setup: {},
  activeContentProductId: null,
  loading: false
};
